var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbol",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Unit/Line",
    transform: "translate(-3.000000, -3.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.25,13.5 C16.2125,13.5 17,14.2875 17,15.25 C17,16.2125 16.2125,17 15.25,17 C14.2875,17 13.5,16.2125 13.5,15.25 C13.5,14.2875 14.2875,13.5 15.25,13.5 Z M7.06066017,6 L14.131728,13.0710678 L13.0710678,14.131728 L6,7.06066017 L7.06066017,6 Z M4.75,3 C5.7125,3 6.5,3.7875 6.5,4.75 C6.5,5.7125 5.7125,6.5 4.75,6.5 C3.7875,6.5 3,5.7125 3,4.75 C3,3.7875 3.7875,3 4.75,3 Z",
    id: "Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.a196c12eceafb32f8d684392d007a8a8.svg";
export { ForwardRef as ReactComponent };